export default __webpack_public_path__ + "static/media/11-abstract_preview.d00f32eb.jpg";